import { SocialTotalVisits } from "app/pages/website-analysis/social-overview/social-total-visits/socialTotalVisits";
import styled from "styled-components";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { i18nFilter } from "app/filters/i18nFilter";
import { minVisitsAbbrFilter } from "app/filters/ngFilters";
import type { IWidgetSingleWrapperProps } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/Types";
import { getMMXTrafficData, getSingleTotalVisitsData } from "app/services/WebsiteAnalysis/SearchOverviewApiService";
import type { IWidgetModelTypesWebSource } from "app/components/widget/widget-types/Widget";
import { AddToDashboard } from "app/components/dashboard/AddToDashboard/AddToDashboard";
import { channels } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewGraph/SearchTrafficInsights/typesAndConstants";
import { sum } from "lodash";
import { useQuery } from "@tanstack/react-query";
import type { FC } from "react";

const TotalVisitsBoxContainer = styled.div`
    margin-right: 20px;
`;

export const TotalVisitsWidgetWrapper: FC<IWidgetSingleWrapperProps> = (props) => {
    const { apiParams, apiParamsObj, subtitleFilters } = props;
    const { webSource, key } = apiParams;
    const device = webSource === devicesTypes.MOBILE ? "Mobile web" : webSource;
    const shareText = i18nFilter()("search.overview.total.visits.share.text", { device: device });
    const isTotal = webSource === devicesTypes.TOTAL;

    const transformData = (data) => {
        if (isTotal) {
            const totalData = data.Data[webSource][key];
            const searchTotal = totalData[channels.ORGANIC] + totalData[channels.PAID];
            const sumOfAllChannels = sum(Object.values(totalData));
            const volumeTotal = searchTotal / sumOfAllChannels;

            const parsedData = { [key]: { SearchTotal: searchTotal, VolumeTotal: volumeTotal } };
            return {
                Data: parsedData,
                dictionary: parsedData,
            };
        }

        return {
            ...data,
            dictionary: data.Data,
        };
    };

    const { data, isLoading } = useQuery({
        queryKey: [`${webSource}SearchOverviewTotalVisitsWidget`, ...Object.values(apiParams)],
        select(dto) {
            return transformData(dto);
        },
        queryFn: () => {
            return isTotal ? getMMXTrafficData(apiParamsObj) : getSingleTotalVisitsData(apiParamsObj);
        },
    });

    const TotalVisitsA2D = () => (
        <AddToDashboard
            modelType="fromWebsite"
            metric="SearchVisitsOverviewV2"
            type="SearchOverviewTotalVisits"
            webSource={webSource as IWidgetModelTypesWebSource}
        />
    );

    return (
        <TotalVisitsBoxContainer>
            <SocialTotalVisits
                type="search"
                loading={isLoading}
                data={data}
                share={data?.Data?.[key].VolumeTotal}
                a2d={TotalVisitsA2D}
                height={"273px"}
                subTitleFilters={subtitleFilters}
                shareText={shareText}
                numberFormat={minVisitsAbbrFilter()}
            />
        </TotalVisitsBoxContainer>
    );
};
